import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const Logo = ({
    className
}) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={'10px'}
            viewBox='0 0 50 10'
            width={'50px'}
            xmlns='http://www.w3.org/2000/svg'>
            <title>Strava</title>
            <path
                clipRule='evenodd'
                d='M26.65 9.6226L26.6497 9.62217H29.2895L30.9111 6.2576L32.5327 9.62217H35.7404L30.9108 -6.10352e-05L26.3264 9.13497L24.5662 6.48281C25.653 5.94196 26.3304 5.00526 26.3304 3.65973V3.63324C26.3304 2.68356 26.0493 1.99749 25.5123 1.44334C24.8858 0.79696 23.8759 0.388024 22.2907 0.388024H17.9184V9.6226H20.91V6.98409H21.5492L23.2367 9.6226H26.65ZM45.0976 -6.10352e-05L40.2687 9.62217H43.4764L45.0979 6.2576L46.7196 9.62217H49.9272L45.0976 -6.10352e-05ZM38.0071 10.0008L42.8361 0.378556H39.6285L38.0068 3.74313L36.3852 0.378556H33.1775L38.0071 10.0008ZM22.2012 4.781C22.917 4.781 23.3518 4.45121 23.3518 3.88398V3.85749C23.3518 3.26387 22.9042 2.97366 22.214 2.97366H20.91V4.781H22.2012ZM11.5209 3.00005H8.88753V0.388024H17.146V3.00005H14.5126V9.6226H11.5209V3.00005ZM1.59814 6.27175L0 8.23739C1.13784 9.26653 2.77423 9.79409 4.58948 9.79409C6.99299 9.79409 8.5399 8.60675 8.5399 6.66739V6.64111C8.5399 4.781 7.00577 4.09494 4.71742 3.65973C3.77134 3.47483 3.52845 3.31675 3.52845 3.066V3.03962C3.52845 2.81536 3.73309 2.65707 4.18041 2.65707C5.01134 2.65707 6.02144 2.93409 6.86505 3.56728L8.32258 1.48302C7.28701 0.638662 6.00866 0.216428 4.28278 0.216428C1.81526 0.216428 0.485773 1.57536 0.485773 3.32983V3.35632C0.485773 5.30866 2.2501 5.90249 4.25711 6.32441C5.21598 6.52239 5.49711 6.66739 5.49711 6.93132V6.95781C5.49711 7.20834 5.26711 7.35334 4.7301 7.35334C3.68186 7.35334 2.56969 7.03696 1.59814 6.27175Z'
                fill='white'
                fillRule='evenodd'/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
};

Logo.propTypes = propTypes;

export default Logo;
